import {getRouteFromCookie} from '../../api/helpers/cookieHelper';
import {useSecurityStore} from '../../stores/securityStore';
import {unwrapRouteQueryValue} from '../../shared/helpers/routeHelper';
import {useInformationStore} from '../../stores/informationStore';

/**
 *
 * @param {RouteLocationNormalized} to
 * @return {NavigationGuardResult}
 */
export const authorizeWithQueryToken = async to => {
    if (!('token' in to.query && 'refreshToken' in to.query)) {
        return;
    }

    const securityStore = useSecurityStore();
    const {refresh} = useInformationStore();

    securityStore.token = unwrapRouteQueryValue(to.query.token);
    securityStore.refreshToken = unwrapRouteQueryValue(to.query.refreshToken);

    securityStore.authType =
        'authType' in to.query ? unwrapRouteQueryValue(to.query.authType) : null;

    delete to.query.token;
    delete to.query.refreshToken;
    delete to.query.authType;

    try {
        await refresh();

        if (['DayBookingOverview', 'FavoriteSeats', 'PresentList'].includes(to.name)) {
            return to;
        }

        return getRouteFromCookie() || {name: 'Home', query: to.query};
    } catch {
        securityStore.clearToken(true);

        return {name: 'Login'};
    }
};
